import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import MaterialTable from 'material-table';
import AskAlert from '../common/AskAlert';
import{ SERVER_PATH, AXIOS_CONFIG , ROLE_VIEWER} from '../common/redux/constantes';
import SelectWorkpackage from './SelectWorkpackage';
// eslint-disable-next-line
import {COST_TYPE_LABOR,COST_TYPE_EQUIPMENT, COST_TYPE_MATERIAL,COST_TYPE_OTHER,COST_TYPE_SUBCONTRACT,} from '../common/redux/constantes';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
} from '../common/redux/constantes';


// import moment from 'moment';
import CreateCostModel from './CreateCostModel';
import MyTooltip from '../common/MyTooltip';



class Cost extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };
  state ={
    costs:[],
    openDeleteAlert:false,
    deleteCostID:-1
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    //bindings
    this.changeWorkpackageSelected = this.changeWorkpackageSelected.bind(this);
    this.deleteCost = this.deleteCost.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
  }

  deleteCost =()=>{
    if(this.state.deleteCostID !== -1){
      this.props.actions.deleteCost(this.tableRef,this.state.deleteCostID);
      this.setState({openDeleteAlert:false});
    }
  }


  cancelDelete = () =>{
    this.setState({openDeleteAlert:false});
  }

  askDeleteCost= (costID)=>{
    this.setState({openDeleteAlert:true, deleteCostID:costID});
  }

  changeWorkpackageSelected(workpackage_id, name)
  {
    this.setState({workpackageSelected:workpackage_id, workpackage_name_selected:name});
    this.refreshTable();
  }  

  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }

   closeCreateCostDialog = ()=>
  {
    this.setState({openCreateCostDialog:false});
    this.refreshTable();
  }

  openCreateCostDialog = ()=>{
    this.setState({
      openCreateCostDialog:true, 
      createCostDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      costEdit:{}
    });
  }

  editCost = (cost)=>{
     this.setState({
      openCreateCostDialog:true, 
      createCostDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      costEdit:cost
    });
  }

  showCost = (cost)=>{
     this.setState({
      openCreateCostDialog:true, 
      createCostDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      costEdit:cost
    });
  }

  
  render() {
      let actionButtons = [
      rowData => ({
        icon: rowData.flag === 1?'':'delete',
        tooltip: rowData.flag === 1?'':'Delete',
        disabled: rowData.flag === 1,
        onClick: (event, rowData) =>rowData.flag === 1?null:this.askDeleteCost(rowData.cost),
      }),
      rowData => ({
        icon: rowData.flag === 1?'':'edit',
        tooltip: rowData.flag === 1?'':'edit',
        disabled: rowData.flag === 1,
        onClick: (event, rowData) => rowData.flag === 1?null:this.editCost(rowData),
      }),
      rowData => ({
        icon: rowData.flag === 1?'':'visibility',
        tooltip: rowData.flag === 1?'':'View information',
        disabled: rowData.flag === 1,
        onClick: (event, rowData) => rowData.flag === 1?null:this.showCost(rowData),
      }),
      {
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
      },
    ];


      //Verificamos permisos
      if(Number(localStorage.getItem("role"))===ROLE_VIEWER)
      {
        actionButtons.splice(0,2);
      }
      return (
        <div >
          <SelectWorkpackage deliverable={this.props.deliverable} changeWorkpackage={this.changeWorkpackageSelected}/>
          <MaterialTable
          tableRef={this.tableRef}
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          options={{
            actionsColumnIndex:7,
            paging:false,
            search:false,
            sorting:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: (rowData) => {
                return {
                backgroundColor: 
                    (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                    '#EEE' 
                    :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                }
            }
          }}
          title="Costs"
          columns={[
            { 
              title: 'Description', 
              field: 'description',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Type', 
              field: 'type', 
              lookup:{
                  1:'Labor',
                  2:'Equipment', 
                  3:'Material',
                  4:'Other', 
                  5:'SubContract'
                },
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
            },
            { 
              title: 'Start Date', 
              field: 'start_date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'End Date', 
              field: 'finish_date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Total Cost', 
              field: 'total_cost',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
          ]}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/costs/getByWorkpackage/' + this.state.workpackageSelected
            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {
                let formatter = null;
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    formatter = new Intl.NumberFormat('gt-GT', {
                      minimumFractionDigits: 2,
                    });
                  }
                result.costs = result.costs.map(o => {
                  if(o.start_date && o.finish_date)
                  {
                    // o.start_date = moment(o.start_date).format('YYYY-MM-DD')
                    // o.finish_date = moment(o.finish_date).format('YYYY-MM-DD')
                  }
                  o.tableData = {isTreeExpanded:true}
                  
                  if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    o.total_cost = formatter.format(o.total_cost);
                  }
                  return o;
                });
                resolve({
                  data: result.costs,
                  page: 0,
                  totalCount: result.costs.length,
                })
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }

          actions={actionButtons}
        />
        <CreateCostModel 
          workpackage={this.state.workpackageSelected} 
          workpackage_name={this.state.workpackage_name_selected} 
          openDialog={this.state.openCreateCostDialog} 
          closeDialog={this.closeCreateCostDialog} 
          actionDialog={this.state.createCostDialogAction}
          costEdit={this.state.costEdit}
          ca={this.props.ca}
          project={this.props.project}
          deliverable={this.props.deliverable}
        />
        {
          Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.state.workpackageSelected > 0?
          (<MyTooltip openDialog={this.openCreateCostDialog} />)
          :null
        }
        <AskAlert openAlert={this.state.openDeleteAlert} handleCloseCancel={this.cancelDelete} handleCloseOk={this.deleteCost}
          dialogTitle="Delete Cost" dialogContent="Are you sure to delete this cost?" />
        </div>
      )
    }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    cost: state.cost,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Cost);



// WEBPACK FOOTER //
// ./src/features/cost/Cost.js